import {
    Button,
    H3,
    Text,
    SimpleText,
    Modal,
    useGeneratePath,
    useStaticUrls,
    ModalCloseProps,
} from 'platform-components';
import { CloseButton } from 'platform-components/src/components/close-button/_view/close-button_view_outer';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { getCurrentOrFirstTeamId } from 'common.components/user/selectors';
import { getTeamIdFromPath } from 'utils/path';

import { personalDataModalActions } from './actions';

import './personal-data-modal.scss';

export const PersonalDataModal = () => {
    const dispatch = useDispatch();
    const teamIdFromPath = getTeamIdFromPath();
    const teamId = useSelector((store) => getCurrentOrFirstTeamId(store, { classId: teamIdFromPath }));
    const getRouterPath = useGeneratePath();
    const { labClassPrint } = useStaticUrls();
    const history = useHistory();

    const redirectOnSuccess = () => {
        if (teamId) {
            history.push(getRouterPath(labClassPrint, { classId: teamId }));
        }
    };

    const handleBtnClick = () => {
        dispatch(
            personalDataModalActions.acceptPersonalDataRequest({
                onSuccess: redirectOnSuccess,
            })
        );
    };

    const handleCloseModal = () => {
        dispatch(personalDataModalActions.acceptPersonalDataRequest());
    };

    return (
        <Modal
            Close={(closeProps: ModalCloseProps) => (
                <CloseButton {...closeProps} position={CloseButton.POSITION.ABSOLUTE} />
            )}
            hasClose
            mix="personal-data-modal"
            onRequestClose={handleCloseModal}
            opened
            theme={Modal.THEMES.TEACHER}
        >
            <Modal.Header>
                <H3 id="personalDataModal.title" weight={Text.WEIGHT.M} />
            </Modal.Header>
            <Modal.Content>
                <div className="personal-data-modal__description">
                    <Text id="personalDataModal.description" type={Text.TYPE.MARKDOWN} />
                </div>
                <div className="personal-data-modal__img" />
                <div className="personal-data-modal__list">
                    <div className="personal-data-modal__list-item">
                        <Text id="personalDataModal.list.1" type={Text.TYPE.MARKDOWN} />
                    </div>
                    <div className="personal-data-modal__list-item">
                        <Text id="personalDataModal.list.2" type={Text.TYPE.MARKDOWN} />
                    </div>
                </div>
            </Modal.Content>
            <Modal.Footer>
                <Button className="personal-data-modal__print-button" onClick={handleBtnClick}>
                    <SimpleText id="personalDataModal.printButton" />
                </Button>
                <Button
                    className="personal-data-modal__cancel-button"
                    onClick={handleCloseModal}
                    view={Button.VIEW.SECONDARY}
                >
                    <SimpleText id="personalDataModal.cancel" />
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
